const { REACT_APP_API_ENV = 'dev' } = process.env;
const pathConfig: any = {
  dev: {
    IS_SHOW_VCONSOLE: true, //是否展示vconsole
    YHXKXY_URL:
      'https://superapp-public.hdltest.com/app-h5-web/user-agreement.html', //用户许可协议
    YSZC_URL:
      'https://superapp-public.hdltest.com/app-h5-web/privacy-policy.html', //隐私政策
    ENV_VERSION: 'trial',
  },
  qa: {
    IS_SHOW_VCONSOLE: true, //是否展示vconsole
    YHXKXY_URL:
      'https://superapp-public.hdltest.com/app-h5-web/user-agreement.html', //用户许可协议
    YSZC_URL:
      'https://superapp-public.hdltest.com/app-h5-web/privacy-policy.html', //隐私政策
    ENV_VERSION: 'trial',
  },
  pro: {
    IS_SHOW_VCONSOLE: false, //是否展示vconsole
    YHXKXY_URL:
      'https://superapp-public.kiwa-tech.com/app-h5-web/user-agreement.html', //用户许可协议
    YSZC_URL:
      'https://superapp-public.kiwa-tech.com/app-h5-web/privacy-policy.html', //隐私政策
    ENV_VERSION: 'release',
  },
};
export default pathConfig[REACT_APP_API_ENV];
/**小程序环境 */
export const ENV_VERSION = pathConfig[REACT_APP_API_ENV].ENV_VERSION;
/**oss cdn域名 */
export const OSS_CDN =
  'https://saas-web.hdlcdns.com/hi-for-bit-good-miniProgram/protocol/';
